<div class="main-content">
    <div class="container-fluid">
        <div class="justify-content-center row">
            <div class="col-12">
                <div class="header">
                    <div class="header-body">
                        <div class="align-items-center row">
                            <div class="col">
                                <h6 class="header-pretitle">Overview</h6>
                                <h1 class="header-title text-truncate">Contracts</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <app-overview *ngIf="appContext.isAdminOrIntermediary()" [query]="query" (dataChange)="data = $event" [windowScroll]="true">
                    <div class="header-bar align-items-center row mb-4">
                        <div class="col-auto">
                            <div class="dropdown">
                                <button class="dropdown-toggle btn border-0 text-start d-flex justify-content-between align-items-center w-100 p-2 pe-4"
                                        type="button" [ngClass]="{'active': selectedConnectionTypes.length > 0}" data-bs-toggle="dropdown"
                                        [style.max-width.px]="200">
                                    <div class="d-flex flex-column mw-0 flex-grow-1 me-3 mw-100">
                                        <span class="d-inline-block text-truncate">Connection Type</span>
                                        <div *ngIf="selectedConnectionTypes.length > 0"
                                             class="mt-1 text-secondary d-inline-block text-truncate notranslate">
                                            {{ selectedConnectionTypes.join(', ') }}
                                        </div>
                                    </div>
                                    <i *ngIf="selectedConnectionTypes.length === 0" class="fa fa-fw fa-plus text-secondary"></i>
                                </button>
                                <div class="btn-close-wrapper rounded-circle position-absolute end-0 me-1 mt-1 top-0"
                                     [ngClass]="{'d-none': selectedConnectionTypes.length === 0}">
                                    <button type="button" class="btn-close" (click)="clearFilter()" aria-label="Remove filter"></button>
                                </div>
                                <div class="dropdown-menu min-w-100 overflow-auto" [style.max-height.px]="320" [style.z-index]="1050">
                                    <ul class="list-group">
                                        <ng-container *ngFor="let connectionType of appContext.connectionTypes; index as i; trackBy: trackByConnectionType">
                                            <li class="list-group-item list-group-item-action border-0 d-flex align-items-stretch">
                                                <div class="d-flex align-items-center">
                                                    <input class="form-check-input m-0 me-1" type="checkbox" [checked]="selectedConnectionTypes.includes(connectionType)"
                                                           (change)="toggleConnectionType($event)" [value]="connectionType" [id]="connectionType">
                                                    <label class="d-flex flex-grow-1" [for]="connectionType" style="cursor: pointer">
                                                        <span class="text-truncate py-1">{{ connectionType }}</span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <app-filter [(filterTerm)]="term" (onUpdate)="executeQuery()" placeholder="Search"></app-filter>
                        </div>
                        <div *ngIf="appContext.isAdminOrIntermediary()" class="col-auto">
                            <button (click)="addContract()" type="button" class="btn btn-primary">
                                <i class="bi bi-plus me-md-2"></i>
                                <span class="d-none d-md-inline">Add Contract</span>
                            </button>
                        </div>
                    </div>
                    <div class="overview-items pb-4">
                        <div class="row mx-0 g-4">
                            <ng-container *ngFor="let record of data; trackBy: trackByForRecord">
                                <div class="col-xl-4 col-md-6 col-12">
                                    <app-contract-overview-item class="h-100 d-flex" [contract]="record"></app-contract-overview-item>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
                        <span class="h1 mb-2">No contracts found</span>
                        <span class="text-secondary">Try adjusting your filters or search term</span>
                    </div>
                </app-overview>
            </div>
        </div>
    </div>
</div>